import { Injectable } from '@angular/core';
import { ManagerEnum } from '@app/shared/enum/Manager.enum';
import { ManagerModel } from '@app/shares/models/manager.model';
import { TradeFilter } from '@app/trade-status/model/trade-filter.model';
import { AuthUser } from '../auth/auth-frame/auth-user.model';

@Injectable({
    providedIn: 'root'
})
export class AuthStorageService  {

    private _authUser: AuthUser;
    private _authError: boolean;
    private _filterByManager: ManagerModel
    private _isLoadBoletaList: Boolean;

    get authUser(): AuthUser {
        return this._authUser;
    }

    get isManagerDCF(): boolean {
        return this._authUser.gestor === ManagerEnum.DCF;
    }

    get isAuthUserError(): boolean {
        return this._authError;
    }

    get filterByManager(): ManagerModel {
        return this._filterByManager;
    }

    set filterByManager(value: ManagerModel) {
        if(value && !this.isManagerDCF) {
            throw new Error('Gerente não possui permissão para mudar o filtro por Gestor');
        }
        this._filterByManager = value;
    }

    get isLoadBoletaList(): Boolean {
        return this._isLoadBoletaList;
    }

    constructor() {
    };

    /**
     * @description método utilizado para se comunicar com o Local Storage
     */
    public loadStorage(): void {
        try {
            if(!this._authUser) {
                this._authUser = JSON.parse(localStorage.getItem('authUser')) as AuthUser;
                this._authError = false;
            }
        }
        catch(error) {
            this._authError = true;
        }
    }

     /**
     * @description método utilizado para identificar o gerente DCF
     */
    public checkManagerDCF(): void {
        if(!this.isManagerDCF) {
            this.filterByManager = null;
        }
    }

    /**
     *
     * @param tableFilter é utilizado para filtrar os dados da Busca
     */
    public checkLoadBoletaList(tableFilter: TradeFilter): void {
        const isTradeType =  !!(tableFilter.tradeTypes && Array.isArray(tableFilter.tradeTypes) && tableFilter.tradeTypes.length > 0);
        const isOrderNumber = !!(tableFilter.ordemNumbers && Array.isArray(tableFilter.ordemNumbers) && tableFilter.ordemNumbers.length > 0);

        this._isLoadBoletaList = !!(isTradeType || isOrderNumber);
    }
}
